import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {OverlayModule} from '@angular/cdk/overlay';
import {PortalModule} from '@angular/cdk/portal';
import {RouterModule} from '@angular/router';
import {DialogModule} from './dialog/dialog.module';
import {AsteriskModule} from 'src/app/directives/mark-asterisk/mark-asterisk.module';

// Components
import {FilterComponent} from './filter/filter.component';
import {DropdownComponent} from './dropdown/dropdown.component';
import {TableComponent} from './table/table.component';
import {TabComponent} from './tab/tab.component';
import {TabListComponent} from './tab-list/tab-list.component';
import {SidebarComponent} from './sidebar/sidebar.component';
import {DatepickerComponent} from './datepicker/datepicker.component';
import {AutocompleteFieldComponent} from './autocomplete-field/autocomplete-field.component';
import {FilterMultiSelectComponent} from './filter-multi-select/filter-multi-select.component';
import {ExportComponent} from './export/export.component';
import {SureModalComponent} from './table/sure-modal/sure-modal.component';
import {AddTableModalComponent} from './table/add-table-modal/add-table-modal.component';
import {SalaryGenerateReportsComponent} from './salary-generate-reports/salary-generate-reports.component';
import {LinkDocModalComponent} from './table/link-doc-modal/link-doc-modal.component';
import {MessengersComponent} from './messengers/messengers.component';
import {LoaderComponent} from './loader/loader.component';

// Pipe
import {CamelCasePipe} from 'src/app/pipes/camel-case.pipe';
import {SortTablePipe} from 'src/app/pipes/sort-table.pipe';
import {ObjectKeyPipe} from 'src/app/pipes/object-key.pipe';
import {DropdownObjectPipe} from 'src/app/pipes/dropdown-object.pipe';
import {TypeofPipe} from 'src/app/pipes/typeof.pipe';
import {CurrentWeekdays} from 'src/app/pipes/current-weekdays.pipe';

// Directive
import {ToggleClassDirective} from 'src/app/directives/toggle-class.directive';
import {ErrorFieldComponent} from './error-field/error-field.component';
import {PaginationComponent} from './pagination/pagination.component';
import {TableModalComponent} from './table/table-modal/table-modal.component';
import {CancelModalComponent} from './table/cancel-modal/cancel-modal.component';
import {SendCredentialsPopupComponent} from 'src/app/components/approval-notification/send-credentials-popup/send-credentials-popup.component';
import {ImageUploaderComponent} from './image-uploader/image-uploader.component';
import {UiTooltipDirective} from 'src/app/directives/ui-tooltip.directive';
import {NgxMaskDirective, provideNgxMask} from 'ngx-mask';
import {FlatpickrModule} from 'angularx-flatpickr';

@NgModule({
  declarations: [
    DatepickerComponent,
    DropdownComponent,
    SidebarComponent,
    TableComponent,
    SortTablePipe,
    CamelCasePipe,
    FilterComponent,
    AutocompleteFieldComponent,
    FilterMultiSelectComponent,
    TabListComponent,
    TabComponent,
    ExportComponent,
    ObjectKeyPipe,
    ToggleClassDirective,
    SureModalComponent,
    AddTableModalComponent,
    SalaryGenerateReportsComponent,
    LinkDocModalComponent,
    MessengersComponent,
    DropdownObjectPipe,
    TypeofPipe,
    LoaderComponent,
    ErrorFieldComponent,
    PaginationComponent,
    TableModalComponent,
    CurrentWeekdays,
    CancelModalComponent,
    ImageUploaderComponent,
  ],
  exports: [
    SidebarComponent,
    TabListComponent,
    TabComponent,
    TableComponent,
    DatepickerComponent,
    SortTablePipe,
    CamelCasePipe,
    DropdownComponent,
    FilterComponent,
    AutocompleteFieldComponent,
    FilterMultiSelectComponent,
    ExportComponent,
    ObjectKeyPipe,
    ToggleClassDirective,
    SalaryGenerateReportsComponent,
    MessengersComponent,
    DropdownObjectPipe,
    TypeofPipe,
    LoaderComponent,
    ErrorFieldComponent,
    ImageUploaderComponent,
    CurrentWeekdays,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlatpickrModule.forRoot(),
    OverlayModule,
    PortalModule,
    RouterModule,
    NgxMaskDirective,
    DialogModule,
    AsteriskModule,
    UiTooltipDirective,
  ],
  providers: [provideNgxMask()],
})
export class UiKitsModule {}
